"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopWindow = void 0;
const window_base_1 = require("./window_base");
const window_type_1 = require("./enums/window_type");
class DesktopWindow extends window_base_1.WindowBase {
    // ---------------------------------------------------------------------------
    constructor(options, id) {
        super(options, id);
    }
    // ---------------------------------------------------------------------------
    type() {
        return window_type_1.WindowType.Desktop;
    }
    // ---------------------------------------------------------------------------
    resize(edge) {
        throw new Error('Method not implemented.');
    }
}
exports.DesktopWindow = DesktopWindow;
//# sourceMappingURL=desktop_window.js.map